import component from "./BackToTop";

export default component;
